import './Machine.css';

const Machine: React.FC = () => {
  return <div className="machine"></div>;
};

export default Machine;
